import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceChip } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { PERSONALITY_OPTIONS } from '../../data/quizOptions';
import { adaptLabel } from '../../utils/gender';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
const MAX = 4;
export function StepPersonality({
  profile,
  update,
  onNext
}: StepProps) {
  const reachedMax = profile.child_personality.length >= MAX;
  return <div className="flex flex-1 flex-col" data-id="element-130" data-mp="241j3tkvi9aoa">
      <Headline data-id="element-131" data-mp="2hzheogamaoz1">¿Cómo describirías a {profile.child_name}?</Headline>
      <Subtext data-id="element-132" data-mp="2d04gizeapvh5">
        Puedes elegir hasta {MAX}.{' '}
        <span className="font-semibold text-violet-600" data-id="element-133" data-mp="2czcsc9n1300w">
          {profile.child_personality.length}/{MAX}
        </span>
      </Subtext>

      <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-134" data-mp="3tg7ar6lbu0ex">
        {PERSONALITY_OPTIONS.map(option => <ChoiceChip key={option.label} emoji={option.emoji} label={adaptLabel(option.label, profile.child_gender)} selected={profile.child_personality.includes(option.label)} disabled={reachedMax} onSelect={() => update({
        child_personality: toggleValue(profile.child_personality, option.label, MAX)
      })} data-id="element-135" data-mp="1lfa9gny92f1m" />)}
      </div>

      <div className="mt-auto pt-10" data-id="element-136" data-mp="11t464um4hw59">
        <PrimaryButton onClick={onNext} disabled={profile.child_personality.length === 0} data-id="element-137" data-mp="16q4b1278ksus">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}